const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1'])

function getHostname(): string {
  if (typeof window === 'undefined') {
    return ''
  }

  return window.location.hostname.toLowerCase()
}

export function isLocalHostname(hostname: string): boolean {
  return LOCAL_HOSTS.has(hostname.toLowerCase())
}

export const isLocalRuntime = isLocalHostname(getHostname())
export const isLockedDownRuntime = !isLocalRuntime

export const isProductionRuntime = import.meta.env.VITE_ENVIRONMENT === 'production'
export const showComingSoonFeatures = !isProductionRuntime
